import React, { useState, useEffect } from 'react';
import { css } from '@emotion/css';
import { getApplicationsForOrg } from '../../../api/controllers/applications';
import ApplicationModel from '../../../models/applications/api/ApplicationModel';
import { breakpoint_small } from '../../../constants/breakpoints';
import JobberIntegration from './Integrations/Jobber';
import SalesforceIntegration from './Integrations/Salesforce';
import ZohoCRMIntegration from './Integrations/zoho/ZohoCRM';
import Facebook from './Integrations/Facebook';

const OrganizationIntegrationsSettings: React.FC<{ organizationId: string }> = ({ organizationId }) => {
    const [applications, setApplications] = useState<ApplicationModel[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchApplications = async () => {
            setIsLoading(true);
            try {
                const result = await getApplicationsForOrg(organizationId);
                if (result.resultType === "Ok" && result.data) {
                    setApplications(result.data);
                }
            } catch (error) {
                console.error('Error fetching applications:', error);
            }
            setIsLoading(false);
        };

        if (organizationId) {
            fetchApplications();
        }
    }, [organizationId]);

    return (
        <div className={integrationsSectionStyle}>
            {isLoading && <span className={loadingStyle}>Loading applications...</span>}
            <JobberIntegration applications={applications} isLoading={isLoading} organizationId={organizationId} />
            <SalesforceIntegration applications={applications} isLoading={isLoading} organizationId={organizationId} />
            <ZohoCRMIntegration applications={applications} isLoading={isLoading} organizationId={organizationId} />
            <Facebook applications={applications} isLoading={isLoading} organizationId={organizationId} />
        </div>
    );
};

const integrationsSectionStyle = css`
    padding: 0px 24px;
    margin-bottom: 64px;
    height: 100%;
    ${breakpoint_small} {
        margin-top: 5px;
        padding: 0px;
    }
`;

const loadingStyle = css`
    display: block;
    margin-top: 8px;
    font-size: 14px;
    color: #333;
`;

export default OrganizationIntegrationsSettings;